import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import * as XLSX from 'xlsx';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Router, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { XlMapperService } from 'src/app/services/xl-mapper.service';
import { Constant } from 'src/app/constant/constant';

@Component({
  selector: 'calsoft-xl-mapper',
  templateUrl: './xl-mapper.component.html',
  styleUrls: ['./xl-mapper.component.scss']
})
export class XlMapperComponent implements OnInit, OnDestroy {
  sanitizedUrl = '';

  currentPath = '';

  filelist: any;
  arrayBuffer: any;
  file: any;

  text: string;

  selectedFile: File | null = null;

  mapperKeys: string[] = [];

  @Input() title: string;

  @Input() type: any;

  @Input() url: any;

  secondFormGroup: UntypedFormGroup;

  isLinear = false;

  orientation: string;

  firstFormGroup: UntypedFormGroup;
  isUploading = false;

  constructor(
    private dialog: MatDialog,
    public loc: Location,
    private _formBuilder: UntypedFormBuilder,
    private leadSourceService: LeadSourceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private xlMapperService: XlMapperService,
    private cdr: ChangeDetectorRef,
  ) {

    this.currentPath = this.router.url || '';
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  textNew: any;


  ngOnInit() {

    if (window.innerWidth > 768) {
      this.orientation = "horizontal"
    } else {
      this.orientation = "vertical"
    }

    this.text = 'Submit';

    this.textNew = 'Upload Product';

    this.title = 'Product Xl Mapper';

    this.initForm();

    this.getAllAttributeList();

    this.attributeYFilter();

    this.secondFormGroup = this._formBuilder.group({
      status: ['', Validators.required]
    });
  }


  addfile(event: any) {
    this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);

    fileReader.onload = () => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);

      let workbook = XLSX.read(data, { type: "array" });
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      if (this.filelist.length > 0) {
        this.mapperKeys = Object.keys(this.filelist[0]);
      }
      console.log("Extracted Titles:", this.mapperKeys);
    }
  }

  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0];
  }

  fileUpload = false;

  uploadFile(): void {
    if (!this.selectedFile) {
      alert("Please select a file first.");
      return;
    }

    this.isUploading = true;

    setTimeout(() => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.selectedFile);

      fileReader.onload = () => {
        try {
          this.arrayBuffer = fileReader.result;
          const data = new Uint8Array(this.arrayBuffer);

          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const rawData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const headers = rawData[0] || [];
          const rows = rawData.slice(1);

          const filelist = rows.map(row => {
            const rowData: any = {};
            headers.forEach((header, index) => {
              rowData[header] = row[index] || '';
            });
            return rowData;
          });

          this.filelist = filelist;

          // Save all headers (even if values are missing in first row)
          this.mapperKeys = headers.filter(h => !!h && typeof h === 'string');

          this.populateSourceMapperFromKeys(this.mapperKeys);

          setTimeout(() => {
            this.fileUpload = true;
            this.secondFormGroup.get('status')?.setValue('uploaded');
            this.isUploading = false;
            this.cdr.detectChanges();
          });

          console.log("Extracted Headers:", this.mapperKeys);
        } catch (err) {
          console.error("Error processing file:", err);
          this.isUploading = false;
          this.cdr.detectChanges();
          this.snackBar.open("Error processing file. Please ensure it is a valid Excel or CSV file.", "×", {
            panelClass: 'error',
            duration: 3000
          });
        }
      };

      fileReader.onerror = () => {
        this.isUploading = false;
        this.cdr.detectChanges();
        this.snackBar.open("Error reading file.", "×", {
          panelClass: 'error',
          duration: 3000
        });
      };
    }, 50);
  }


  back() {
    this.loc.back();
  }


  goToStep3(stepper: MatStepper) {
    if (this.secondFormGroup.valid) {
      stepper.next();
    } else {
      this.secondFormGroup.markAllAsTouched();
    }
  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      name: [''],
      sourceMapper: this._formBuilder.array([
        this.initSourceMapper()
      ]),

    });
  }

  initSourceMapper(): UntypedFormGroup {
    return this._formBuilder.group({
      sourceMapperId: [''],
      sourceId: [''],
      formFields: [''],
      fieldMapper: [''],
      type: [0],
      isActive: [0],
    });
  }

  addOption() {

    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).push(
      this.initSourceMapper()
    );

  }


  populateSourceMapperFromKeys(keys: string[]) {
    const control = <UntypedFormArray>this.firstFormGroup.get('sourceMapper');
    control.clear();

    keys.forEach(key => {
      control.push(this._formBuilder.group({
        sourceMapperId: [''],
        sourceId: [''],
        formFields: [''],
        fieldMapper: [key],
        type: [0],
        isActive: [1],
      }));
    });
  }

  removeOption(i) {
    (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).removeAt(i);
  }


  //attribute
  attributeList: any = [];
  attributeTypeList: any = [];
  filteredAttributeTypeList: any = [];
  attributeControl: UntypedFormControl = new UntypedFormControl();
  attributeFilterControl: UntypedFormControl = new UntypedFormControl();

  protected _onDestroy = new Subject<void>();

  getAllAttributeList() {

    this.leadSourceService.getDropDownOnly1(4).subscribe(
      data => {
        this.attributeList = data;

        let object = [

          { attributeCode: "name", frontendLabel: "Name" },
          { attributeCode: "description", frontendLabel: "Description" },
          { attributeCode: "sku", frontendLabel: "SKU" },
          { attributeCode: "Category", frontendLabel: "Category" },
          { attributeCode: "subCategory", frontendLabel: "SubCategory" },
          { attributeCode: "brand", frontendLabel: "Brand" },
          { attributeCode: "imageLink", frontendLabel: "ImageLink" },
          { attributeCode: "subBrand", frontendLabel: "Sub Brand" },
          { attributeCode: "short_description", frontendLabel: "Short Description" },
          { attributeCode: "visibility", frontendLabel: "Visibility" },
          { attributeCode: "isCustomized", frontendLabel: "Is Customized" },
          { attributeCode: "MapLink", frontendLabel: "Map Link" },
          { attributeCode: "supplier", frontendLabel: "Supplier" },
          { attributeCode: "CustomProductResource", frontendLabel: "Custom Product Resource" },
          { attributeCode: "weight", frontendLabel: "Weight" },
          { attributeCode: "featured", frontendLabel: "Featured" },
          { attributeCode: "country_of_manufacture", frontendLabel: "Country of Manufacture" },
          { attributeCode: "product_seo_name", frontendLabel: "SEO Name" },
          { attributeCode: "image", frontendLabel: "Image" },
          { attributeCode: "meta_title", frontendLabel: "Meta Title" },
          { attributeCode: "meta_keyword", frontendLabel: "Meta Keyword" },
          { attributeCode: "meta_description", frontendLabel: "Meta Description" },
          { attributeCode: "price", frontendLabel: "Price" },
          { attributeCode: "special_price", frontendLabel: "Special Price" },
          { attributeCode: "Units", frontendLabel: "Units" },
          { attributeCode: "WholeSalePrice", frontendLabel: "Wholesale Price" },
          { attributeCode: "WholeSaleDiscountPrice", frontendLabel: "Wholesale Discount Price" },
          { attributeCode: "discountPrice", frontendLabel: "Discount Price" },
          { attributeCode: "MaterialCost", frontendLabel: "Material Cost" },
          { attributeCode: "isInStock", frontendLabel: "Is InStock" },
          { attributeCode: "manageStock", frontendLabel: "Manage Stock" },
          { attributeCode: "qty", frontendLabel: "Qty" },
          { attributeCode: "image", frontendLabel: "image" },
          { attributeCode: "video_id", frontendLabel: "video Id" },
          { attributeCode: "featured", frontendLabel: "featured" },
          { attributeCode: "minSaleQty", frontendLabel: "Min Sale Qty" },
          { attributeCode: "maxQty", frontendLabel: "Max Qty" },
          { attributeCode: "notifyStockQty", frontendLabel: "Notify Stock Qty" },
          { attributeCode: "enableQtyIncrements", frontendLabel: "Enable Qty Increments" },
          { attributeCode: "tax_class_id", frontendLabel: "Tax" },
          { attributeCode: "parentId", frontendLabel: "Parent Id" },
        ];

        this.attributeList.push(...object);

          this.attributeTypeList = [...this.attributeList];
          this.filteredAttributeTypeList = [...this.attributeTypeList];

      }
    )

    this.attributeYFilter();

  }


  getAllAttribute() {
    this.filteredAttributeTypeList = this.attributeTypeList;
  }

  attributeYFilter() {
    this.attributeFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.attributeFilter();
      });
  }

  protected attributeFilter() {

      if (!this.attributeList) {
    return;
  }

  let search = this.attributeFilterControl.value;

  if (!search) {
    this.filteredAttributeTypeList = this.attributeTypeList.slice();
    return;
  }

  search = search.toLowerCase();

  this.filteredAttributeTypeList = this.attributeTypeList.filter(attribute => {
    const label = attribute['frontendLabel'];
    return label && label.toLowerCase().includes(search);
  });
  
  }

  goToStep(stepper: MatStepper) {
    if (this.firstFormGroup.valid) {
      stepper.next();
      this.submit();
    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  finalUpload(stepper: MatStepper) {

    this.textNew = "Processing"

    this.xlMapperService.updateProductXl(this.mappedPreview).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.textNew = "Upload Product";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          stepper.next();

        }
        else {
          this.textNew = "Upload Product";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => { this.textNew = "Upload Product" });

  }

  displayedFormFields: string[] = [];

  mappedPreview: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }

  submit(): void {
    if (this.firstFormGroup.valid) {
      this.text = 'Processing';

      setTimeout(() => {
        const formData = this.firstFormGroup.value;

        this.mappedPreview = this.filelist.map((row) => {
          const mappedRow: any = {};
          formData.sourceMapper.forEach((map) => {
            if (map.fieldMapper && map.formFields) {
              mappedRow[map.formFields] = row[map.fieldMapper] || '';
            }
          });
          return mappedRow;
        }).filter(row =>
          Object.values(row).some(value => value !== '' && value != null)
        );

        this.displayedFormFields = formData.sourceMapper
          .filter(map => map.formFields)
          .map(map => map.formFields);
          
        this.dataSource.data = this.mappedPreview;

        this.text = 'Submit';
        this.cdr.detectChanges();
      }, 500);

    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }


  deleteRow(row: any): void {
    const index = this.mappedPreview.indexOf(row);
    if (index !== -1) {
      this.mappedPreview.splice(index, 1);
      this.mappedPreview = [...this.mappedPreview];
      this.dataSource.data = this.mappedPreview;
      this.cdr.detectChanges();
    }
  }



  goToProductPage() {
    this.router.navigate(['/product'])
  }

  isFieldAlreadySelected(attributeCode: string, currentIndex: number): boolean {
    const sourceMapper = this.firstFormGroup.get('sourceMapper').value;


    return sourceMapper.some((group, index) => {
      return index !== currentIndex && group.formFields === attributeCode;
    });
  }

  listOfAttributeSelected: any = [];

  selectedData(event, eavAttribute) {

    if (event.isUserInput != false) {
      if (event.source._selected) {
        this.listOfAttributeSelected.push(eavAttribute.attributeId);

      } else {
        let index = this.listOfAttributeSelected.findIndex(x => x == eavAttribute.attributeId)
        this.listOfAttributeSelected.splice(index, 1);

      }
    }

  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
